module.exports = __webpack_public_path__ + "img/abbb_pack.7d530b5a.png";